import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Statistics from "../../../../components/Statistics/StatisticsActivityList/statistics";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  MINHAS_TRILHAS_CREATE_PATH,
  TRILHA_BREADCRUMB_LISTAGEM,
  isTrailQueryActive
} from "../../../../config/minhasTrilhas";
import { descricaoEmTextoPlano } from "../../../../utils/descricaoAtividade";

class ActivityList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      statisticsModal: false,
      selectedActivityId: null
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.loadList();
  }

  componentDidUpdate(prevProps) {
    // /activity/list e /activity/list?trail=true usam a mesma Route, então
    // alternar entre "Atividades" e "Minhas trilhas" não remonta o componente:
    // é preciso recarregar a lista quando a query string muda.
    if (prevProps.location?.search !== this.props.location?.search) {
      this.setState({ loading: true }, () => this.loadList());
    }
  }

  loadList() {
    const isTrail = this.isTrail();
    let obj = {
      user_id: this.props.user.user.id,
      ability_id: 0,
      difficulty_level_id: 0,
      year: 0,
      type_id: 0,
      // Em "Minhas trilhas" o backend devolve só as atividades com is_trail = true
      isTrail
    };

    axios
      .post(`${URL.api}activity/activity/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        for (let i = 0; i < resp.data.data.length; i++) {
          if (resp.data.data[i].private === true) {
            resp.data.data[i].private = "Sim";
          } else if (resp.data.data[i].private === false) {
            resp.data.data[i].private = "Não";
          }
        }
        this.setState(
          {
            list: resp.data.data.filter(item => {
              if (![1, 3].includes(item.type_id)) return false;
              // "Minhas trilhas" mostra só trilhas; a listagem de atividades
              // mostra só o que não é trilha (is_trail false ou null).
              return isTrail
                ? item.isTrailView === true
                : item.isTrailView !== true;
            })
          },
          () => {
            this.state.list.forEach(obj => this.renameKey(obj, "name", "nome"));
            this.state.list.forEach(obj =>
              this.renameKey(obj, "description", "descrição")
            );
            this.state.list.forEach(obj =>
              this.renameKey(obj, "type_name", "tipo")
            );
            // Aqui a descrição é só texto de célula, e ela chega em quatro formatos
            // diferentes (ver `utils/descricaoAtividade.js`). O código anterior fazia
            // `item.descrição.substring(0, 1)` direto no valor da API: uma trilha
            // criada sem descrição tem `description` NULL no banco, e o TypeError
            // derrubava o `ActivityList` inteiro — o professor via tela branca no
            // lugar da lista, sem nem chegar às trilhas que abrem.
            this.state.list.forEach(item => {
              item.descrição = descricaoEmTextoPlano(item.descrição);
            });

            this.setState({
              loading: false
            });
          }
        );
      });
  }

  // Listagem aberta como "Minhas trilhas" (/activity/list?trail=true).
  // Derivado das props a cada uso: /activity/list e /activity/list?trail=true
  // compartilham a mesma Route, então o componente não remonta entre elas.
  isTrail = () => isTrailQueryActive(this.props.location?.search);

  renameKey = (obj, oldKey, newKey) => {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  };

  getArray = data => {
    const header = ["id", "nome", "descrição", "tipo"];
    const arr = [header];
    data.forEach(item => {
      arr.push([item.id, item.nome, item.descrição, item.tipo]);
    });
    return arr;
  };

  downloadFileAction = async activity => {
    if (!activity.file_link) {
      toastr.warning(
        "Atenção",
        `A ${
          this.isTrail() ? "trilha" : "atividade"
        } não possui arquivo para download`
      );
      return;
    }

    try {
      const response = await fetch(activity.file_link);
      if (!response.ok) {
        toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = activity.file_name || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toastr.error("Erro", "Ocorreu um erro ao tentar baixar o arquivo");
    }
  };

  insertAction = () => {
    this.props.history.push(
      this.isTrail() ? MINHAS_TRILHAS_CREATE_PATH : "/activity/create"
    );
  };

  // Função de exclusão atualizada
  deleteAction = async arrayRow => {
    try {
      this.setState({ loading: true });

      for (const row of arrayRow) {
        const obj = { id: row };
        await axios.post(`${URL.api}activity/activity/delete`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        });
      }

      // Atualiza lista local
      this.setState(prevState => ({
        list: prevState.list.filter(item => !arrayRow.includes(item.id)),
        loading: false
      }));

      toastr.success(
        "Sucesso",
        this.isTrail()
          ? "Trilha(s) excluída(s) com sucesso!"
          : "Prova(s) excluída(s) com sucesso!"
      );
    } catch (error) {
      this.setState({ loading: false });
      toastr.error(
        "Erro",
        this.isTrail()
          ? "Ocorreu um erro ao tentar excluir a(s) trilha(s)."
          : "Ocorreu um erro ao tentar excluir a(s) prova(s)."
      );
    }
  };

  // Alocar e Editar precisam levar o trail=true adiante, senão a tela de
  // destino perde as travas, os textos e o breadcrumb de trilha.
  allocateAction = row => {
    this.props.history.push(
      `/activity/allocate/${row.id}${this.isTrail() ? "?trail=true" : ""}`
    );
  };

  editAction = row => {
    this.props.history.push(
      `/activity/create/${row.id}${this.isTrail() ? "?trail=true" : ""}`
    );
  };

  reportAction = row => {
    if (row.tipo.toUpperCase() === "TV") {
      this.props.history.push(`/activity/tv/report/${row.id}`);
    } else {
      this.setState({ statisticsModal: true, selectedActivityId: row.id });
    }
  };

  getSelected = selecteds => {
    this.setState({
      // selectedQuestions: selecteds
    });
  };

  render() {
    const isTrail = this.isTrail();

    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            activity_id={this.state.selectedActivityId}
            currentRoute={this.props.currentRoute}
            title={
              this.state.list.find(
                item => item.id === this.state.selectedActivityId
              )?.nome
            }
          />
        )}
        <div className="animated fadeIn">
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : (
            <Row>
              <Breadcrumb
                current={this.props.currentRoute}
                currentName={isTrail ? TRILHA_BREADCRUMB_LISTAGEM : undefined}
              />
              {this.state.list ? (
                <div id="list">
                  <DataTable
                    noSort
                    responsiveCards
                    list={this.state.list}
                    path="/activity/create/"
                    title={isTrail ? "Trilhas" : "Atividades"}
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "nome", denomination: "Nome" },
                      { name: "descrição", denomination: "Descrição" },
                      { name: "tipo", denomination: "Tipo" }
                    ]}
                    insert
                    delete
                    insertAction={this.insertAction}
                    getSelected={this.getSelected}
                    action
                    btnEdit
                    btnAllocate
                    btnDownloadFile
                    btnReport
                    editAction={this.editAction}
                    allocateAction={this.allocateAction}
                    reportAction={this.reportAction}
                    deleteAction={this.deleteAction}
                    downloadFileAction={this.downloadFileAction}
                  />
                </div>
              ) : (
                <Loading top="45" left="50" />
              )}
            </Row>
          )}
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);
